import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';

const HomePage = lazy(() => import('./pages/HomePage'));
const GamesPage = lazy(() => import('./pages/GamesPage'));
const PlayPage = lazy(() => import('./pages/PlayPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const ComingPage = lazy(() => import('./pages/ComingPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage'));
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'));
const ThankYouPage = lazy(() => import('./components/ThankYouPage'));
const ContactThankYouPage = lazy(() => import('./components/ContactThankYouPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const DostKazigiPage = lazy(() => import('./dost-kazigi/DostKazigiPage'));

const PageRoutes = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<div className="page-loader">Loading...</div>}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -3 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
          >
            <Routes location={location}>
              <Route path="/" element={<HomePage />} />
              <Route path="/games" element={<GamesPage />} />
              <Route path="/play" element={<PlayPage />} />
              <Route path="/play/dost-kazigi" element={<DostKazigiPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/coming" element={<ComingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/thanks" element={<ThankYouPage />} />
              <Route path="/contact-thanks" element={<ContactThankYouPage />} />
            </Routes>
          </motion.main>
        </AnimatePresence>
      </Suspense>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App bg-gaming-darker min-h-screen">
      <AuthProvider>
        <Router basename={process.env.PUBLIC_URL || '/'}>
          <PageRoutes />
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
